module.exports = require("core-js-pure/features/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js
// module id = 4334
// module chunks = 25